import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeGlimpseAlert,
  openGlimpseAlert,
  closeSngAlert,
  openSngAlert,
  closeStipaAlert,
  closeSyncAlert,
  openStipaAlert,
  openSyncAlert,
} from ".";

export const useAlerts = () => {
  const dispatch = useDispatch();
  const alertState = useSelector((state) => state.alerts);

  const handleGlimpseOpen = useCallback(() => {
    return dispatch(openGlimpseAlert());
  }, [dispatch]);

  const handleGlimpseClose = useCallback(() => {
    return dispatch(closeGlimpseAlert());
  }, [dispatch]);

  const handleSngOpen = useCallback(() => {
    return dispatch(openSngAlert());
  }, [dispatch]);

  const handleSngClose = useCallback(() => {
    return dispatch(closeSngAlert());
  }, [dispatch]);

  const handleStipaOpen = useCallback(() => {
    return dispatch(openStipaAlert());
  }, [dispatch]);

  const handleStipaClose = useCallback(() => {
    return dispatch(closeStipaAlert());
  }, [dispatch]);

  const handleSyncOpen = useCallback(() => {
    return dispatch(openSyncAlert());
  }, [dispatch]);

  const handleSyncClose = useCallback(() => {
    return dispatch(closeSyncAlert());
  }, [dispatch]);

  return {
    // State
    showGlimpseAlert: alertState.showGlimpseAlert,
    showSngAlert: alertState.showSngAlert,
    showStipaAlert: alertState.showStipaAlert,
    showSyncAlert: alertState.showSyncAlert,

    // Actions
    openGlimpseAlert: handleGlimpseOpen,
    closeGlimpseAlert: handleGlimpseClose,
    openSngAlert: handleSngOpen,
    closeSngAlert: handleSngClose,
    openStipaAlert: handleStipaOpen,
    closeStipaAlert: handleStipaClose,
    openSyncAlert: handleSyncOpen,
    closeSyncAlert: handleSyncClose,
  };
};
